<template>
  <div class="summary-card-container" @click="onClick">
    <div class="summary-card" :style="cardStyle">
      <slot></slot>
    </div>
  </div>
</template>

<script>
export default {
  props: ['onClick', 'cardStyle'],
};
</script>

<style lang="scss" scoped>
@import '@/assets/scss/variables.scss';
.summary-card-container {
  margin: $spacer;
}
.summary-card {
  position: relative;
  padding: $spacer * 1.5;
  box-shadow: 1px 1px 10px rgba(0, 0, 0, 0.1);
  border-radius: 5px;
  transition: all .3s ease-out;
}
.summary-card:hover {
  cursor: pointer;
  box-shadow: 5px 5px 10px rgba(0, 0, 0, 0.5);
}

@media (max-width: 575.98px) {
  .summary-card-container {
    margin: 0;
  }
}
</style>
